import { Component, h } from 'preact';
import cx from 'classnames';

import { Listing } from '../../../../../types';
import { formatAsColloquialDate } from '../../../../core/date-formatter';


const INQUIRY_UPDATE_OPTIONS = [
  'Inquired, client no longer interested',
  'Tried to contact, no answer',
  'Contacted, property not available',
  'Viewing to be rescheduled',
  'Client interested to make an offer',
];


interface InqPropCardAvailabilitySectionProps {
  listing: Listing;
  progressStatus?: string;

  inFinalList: boolean;
  inDetailsCard: boolean;

  onRemoveFromListClick?: (listing: Listing) => void;
  onAddToListClick?: (listing: Listing) => void;
  onProgressUpdate?: (progress: string) => void;
}

export class InqPropCardAvailabilitySection extends Component<InqPropCardAvailabilitySectionProps> {
  onAddToListClick() {
    if (this.props.onAddToListClick) {
      this.props.onAddToListClick(this.props.listing);
    }
  }

  onRemoveFromListClick() {
    if (this.props.onRemoveFromListClick) {
      this.props.onRemoveFromListClick(this.props.listing);
    }
  }

  onProgressStatusUpdate(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;

    if (value !== 'Select') {
      this.props.onProgressUpdate(value);
    }
  }

  render(props: InqPropCardAvailabilitySectionProps) {
    const { listing } = props;
    const listingIsAvailable = listing.feStatus === 'Available';

    return (
      <div className="hi-inqpropcard__availability-group">
        <ul className="hi-inqpropcard__availability-list list-unstyled">
          <li>
            <i className={ cx('fas', {
              'fa-check-circle': listingIsAvailable,
              'fa-exclamation-triangle': !listingIsAvailable
            }) } /> { listing.feStatus }
          </li>
          <li>Updated: { formatAsColloquialDate(listing.dateModified) }</li>
        </ul>

        {/* "Add to list" is hidden when in the final list */}
        { !props.inDetailsCard && !props.inFinalList && (
          <button className="hi-inqpropcard__add-to-list-button btn btn-outline-dark"
            onClick={ () => this.onAddToListClick() }>
            Add to list
          </button>
        )}

        {/* The Inquiry Update section is only shown when in the final list */}
        { props.inFinalList && (
          <div className="hi-inqpropcard__inqupdate">
            <label className="hi-inqpropcard__inqupdate-label">Inquiry Update</label>
            <select className="form-control hi-inqpropcard__inqupdate-select"
              value={ this.props.progressStatus || 'Select' }
              onChange={ event => this.onProgressStatusUpdate(event) }>
              <option selected disabled>Select</option>
              { INQUIRY_UPDATE_OPTIONS.map(option => (
                <option value={ option }>{ option }</option>
              )) }
            </select>
          </div>
        )}

        {/* <button className="btn btn-link hi-inqpropcard__contact-uploader-button">
          <span className="d-lg-none">Contact uploader</span>
          <span className="d-none d-lg-block">
            <span className="hi-inqpropcard__contact-inquire-updated">
              Inquire updated details
            </span>
            &nbsp;
            <i className="far fa-question-circle" />
          </span>
        </button> */}

        <button className="btn btn-link hi-inqpropcard__remove-from-list-button"
          onClick={ () => this.onRemoveFromListClick() }>
          Remove from list
        </button>
      </div>
    )
  }
}
